import React from "react";
import { Field } from "formik";
import { TextField } from "@material-ui/core";

const NameField = ({ touched, errors, label }) => (
  <Field
    as={TextField}
    label={label}
    name="name"
    fullWidth
    margin="dense"
    error={touched.name && Boolean(errors.name)}
    helperText={touched.name && errors.name}
  />
);

export default NameField;
